import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=44cdb1fd&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=44cdb1fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cdb1fd",
  null
  
)

export default component.exports